import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "login-stage" }
const _hoisted_3 = {
  key: 0,
  class: "login"
}
const _hoisted_4 = { class: "login-form" }
const _hoisted_5 = { class: "alternative-login-options" }
const _hoisted_6 = {
  class: "auth-footer",
  "aria-label": "Adereso BSP information and resources"
}
const _hoisted_7 = {
  class: "auth-footer__resources",
  "aria-label": "Adereso resources"
}
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "auth-footer__bottom" }
const _hoisted_10 = {
  class: "auth-footer__legal",
  "aria-label": "Legal information"
}
const _hoisted_11 = ["href"]

import { getAuth, signInWithEmailAndPassword, GoogleAuthProvider, FacebookAuthProvider, signInWithPopup } from 'firebase/auth'
import { POSITION, useToast } from 'vue-toastification'
import AuthService from '../services/AuthService/AuthService'
import { useRouter, useRoute } from 'vue-router'
import { onMounted, ref } from 'vue'
import SpinnerLoader from '../components/loaders/SpinnerLoader.vue'
import { AButton, AInput } from '@adereso-ai/vue-components'


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const toast = useToast()
const email = ref('')
const password = ref('')
const loading = ref(true)
const appVersion = process.env.VUE_APP_VERSION || '0.1.0'

const footerResources = [
  {
    label: 'Help Center',
    href: 'https://help.adereso.ai/'
  },
  {
    label: 'Platform Status',
    href: 'https://adereso.statuspage.io/'
  },
  {
    label: 'Blog',
    href: 'https://adereso.ai/blog/'
  }
]

const legalLinks = [
  {
    label: 'Privacy Policy',
    href: 'https://adereso.ai/politica-de-privacidad/'
  },
  {
    label: 'Terms and Conditions',
    href: 'https://adereso.ai/terminos-y-condiciones/'
  }
]

onMounted(async () => {
  await router.isReady()
  const authService = await AuthService.getInstance()
  if (authService.currentUser.value != null) {
    router.push({ name: 'home', query: route.query })
  }
  loading.value = false
})

async function loginWithEmailAndPassword () {
  const auth = getAuth()
  loading.value = true

  if (email.value === '' || password.value === '') {
    toastError('Email and password are required')
    loading.value = false
    return
  }

  signInWithEmailAndPassword(auth, email.value, password.value)
    .then((result) => {
      const user = result.user
      handleUserLogin(user)
    })
    .catch((error) => {
      toastError(error)
      loading.value = false
    })
}

function moveToRegister () {
  router.push('/register')
}

async function loginWithGoogle () {
  const auth = getAuth()
  const provider = new GoogleAuthProvider()
  loading.value = true

  signInWithPopup(auth, provider)
    .then((result) => {
      // The user is signed in with Google.
      const user = result.user
      handleUserLogin(user)
    })
    .catch((error) => {
      toastError(error)
      loading.value = false
    })
}

async function loginWithFacebook () {
  const auth = getAuth()
  const provider = new FacebookAuthProvider()
  loading.value = true

  signInWithPopup(auth, provider)
    .then((result) => {
      // The user is signed in with Facebook.
      const user = result.user
      handleUserLogin(user)
    })
    .catch((error) => {
      toastError(error)
      loading.value = false
    })
}

async function handleUserLogin (user: any) {
  const token = await user.getIdToken()
  // send token to backend
  const authService = await AuthService.getInstance(token)
  await authService.loginWithIdToken()
  // redirect to dashboard
  router.push('/home')
}

function toastError (errorMessage: string) {
  try {
    toast.error(String(errorMessage), {
      position: POSITION.BOTTOM_LEFT
    })
  } catch (error) {
    console.log('error on toast:', error)
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "auth-heading" }, [
                _createElementVNode("span", { class: "auth-heading__eyebrow" }, "Adereso BSP"),
                _createElementVNode("h1", null, "Welcome back"),
                _createElementVNode("p", null, "Manage your WhatsApp Business operation in one place.")
              ], -1)),
              _createVNode(_unref(AInput), {
                modelValue: email.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                type: "email",
                label: "Email address",
                placeholder: "name@company.com",
                "prepend-inner-icon": "tabler:mail"
              }, null, 8, ["modelValue"]),
              _createVNode(_unref(AInput), {
                modelValue: password.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                type: "password",
                label: "Password",
                placeholder: "Enter your password",
                "prepend-inner-icon": "tabler:lock",
                "show-visibility-toggle": "",
                onKeyup: _withKeys(loginWithEmailAndPassword, ["enter"])
              }, null, 8, ["modelValue"]),
              _createVNode(_unref(AButton), {
                color: "blue",
                block: "",
                onClick: loginWithEmailAndPassword
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode(" Sign in ", -1)
                ]))]),
                _: 1
              }),
              _createElementVNode("div", { class: "alternative-option" }, [
                _cache[3] || (_cache[3] = _createTextVNode(" Don't have an account yet? ", -1)),
                _createElementVNode("span", { onClick: moveToRegister }, "Create account")
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "auth-divider" }, "You can also continue with", -1)),
              _createVNode(_unref(AButton), {
                variant: "outlined",
                color: "base",
                block: "",
                "prepend-icon": "tabler:brand-google",
                onClick: loginWithGoogle
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode(" Google ", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_unref(AButton), {
                variant: "outlined",
                color: "blue",
                block: "",
                "prepend-icon": "tabler:brand-facebook",
                onClick: loginWithFacebook
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode(" Facebook ", -1)
                ]))]),
                _: 1
              })
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("div", {
              class: "alert alert-warning alert-dismissible fade show mt-5 d-none",
              role: "alert",
              id: "alert_1"
            }, [
              _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "alert",
                "aria-label": "Close"
              })
            ], -1))
          ]))
        : (_openBlock(), _createBlock(SpinnerLoader, { key: 1 }))
    ]),
    _createElementVNode("footer", _hoisted_6, [
      _createElementVNode("nav", _hoisted_7, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(footerResources, (resource) => {
          return _createElementVNode("a", {
            key: resource.label,
            href: resource.href,
            target: "_blank",
            rel: "noopener noreferrer"
          }, _toDisplayString(resource.label), 9, _hoisted_8)
        }), 64))
      ]),
      _cache[10] || (_cache[10] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("nav", _hoisted_10, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(legalLinks, (link) => {
            return _createElementVNode("a", {
              key: link.label,
              href: link.href,
              target: "_blank",
              rel: "noopener noreferrer"
            }, _toDisplayString(link.label), 9, _hoisted_11)
          }), 64))
        ]),
        _cache[9] || (_cache[9] = _createElementVNode("p", null, "Adereso - Omnichannel customer service software", -1)),
        _createElementVNode("p", null, "v" + _toDisplayString(_unref(appVersion)), 1)
      ])
    ])
  ]))
}
}

})